import { FC, useEffect, useRef } from 'react';
import Link from 'next/link';
import styles from './BookInfoDownload.module.scss';
import { getAuthorFullName } from '@/helpers/helpers';
import BookMidBtn from '../book-mid-btn/BookMidBtn';
import LitresAudioPlayer from '../litres-audio-player/LitresAudioPlayer';
import BookInfoImg from '../book-info-img/BookInfoImg';
import { BTN_DOWNLOAD_LFROM, DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { getStoreLocal } from '@/helpers/localStorage';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IBookInfoDownload {
  book: IBookShortDetail;
  formRef: React.RefObject<HTMLDivElement>;
}

const BookInfoDownload: FC<IBookInfoDownload> = ({ book, formRef }) => {
  const { files } = book;
  const { type, title, external_id } = book.book;
  const { first_name, middle_name, last_name, alias } = book.author;

  const authorFullName = getAuthorFullName(first_name, middle_name, last_name);
  const authorFullAlias = `/avtor/${alias}/`;

  const refFormatName = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const DOWNLOAD_TXT = 'в формате';
    const savedDownloadLink = getStoreLocal('book-fragment-download-link');
    const formatName = getStoreLocal('book-fragment-name');
    refFormatName.current!.innerText = ` ${DOWNLOAD_TXT} ${!!formatName ? formatName : ''}`;
    setTimeout(() => {
      if (!!formatName) {
        window.location.assign(savedDownloadLink);
      }
    }, 3500);
  });

  return (
    <>
      <div className={styles.bookInfo}>
        <BookInfoImg book={book} formRef={formRef} />

        <div className={styles.bookInfo__desc}>
          <div className={styles.bookInfo__descWrap}>
            <h1 className={styles.bookInfo__tile} data-widget-litres-book="1">
              Скачать"{title}"<span className={styles.bookInfo__tileFormat} data-format-name ref={refFormatName}></span>
            </h1>
            <div className={styles.bookInfo__author}>
              <Link prefetch={false} href={authorFullAlias} data-widget-litres-author="1" itemProp="author">
                {authorFullName}
              </Link>
            </div>

            <div className={styles.bookInfoProgressBar}>
              <div className={styles.bookInfoProgressBar__item}>
                <span data-loading-bg className={`${styles.bookInfoProgressBar__itemBg} ${styles.bookInfoProgressBar__itemBg_active}`} data-progress="100">
                  {' '}
                </span>
              </div>

              {book.hide_litres_data !== true && (
                <div className={styles.bookInfoProgressBar__txt}>
                  Если загрузка не началась
                  <a className={styles.bookInfoProgressBar__link} target="_blank" rel="nofollow" href={`https://www.litres.ru/pages/biblio_book/?art=${book.book.external_id}&lfrom=${BTN_DOWNLOAD_LFROM}`}>
                    Нажмите сюда
                  </a>
                </div>
              )}
            </div>

            {files && files.length > 0 && (
              <div className={styles.bookInfo__category}>
                <span className={styles.bookInfo__categoryName}>Бесплатный фрагмент:</span>
                {files.map((file) => (
                  <Link
                    prefetch={false}
                    target="_blank"
                    key={`${file.type}`}
                    href={`${DEV_ABSOLUTE_URL}/trial/${file.type === 'mp3' ? 'mp3' : `${file.type === 'pdf' ? 'pdf' : 'txt'}`}/${file.external_file_id}.${file.type}`}
                    className={`${styles.bookInfo__categoryLink} ${styles.bookInfo__categoryLink_format}`}
                  >
                    {file.type}
                  </Link>
                ))}
              </div>
            )}

            {type === 'audio_book' ? (
              <div className={styles.bookInfo__category}>
                <span className={`${styles.bookInfo__categoryName} ${styles.bookInfo__categoryName_audio}`}>Слушать онлайн бесплатно:</span>
                <LitresAudioPlayer externalId={external_id} noMargin />
              </div>
            ) : (
              ''
            )}
          </div>

          {book.hide_litres_data !== true && (
            <div className={styles.bookInfo__buttons}>
              <div className={styles.bookInfo__downloadBtn}>
                <BookMidBtn txt="Купить и скачать" href={`https://www.litres.ru/pages/biblio_book/?art=${book.book.external_id}&lfrom=${BTN_DOWNLOAD_LFROM}`} target="_blank" rel="nofollow" />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BookInfoDownload;
